import React from 'react';
import PropTypes from 'prop-types';
import {Form, Label} from "semantic-ui-react";
import {FormattedMessage} from "react-intl";

const TextInput = (props) => (
    <Form.Field>
        {props.required ? <i className="asterisk icon inline"/> : ""}
        {props.label}
        <Form.Input type={props.password ? "password" : "text"}
                    name={props.name}
                    disabled={props.disabled}
                    loading={props.loading}
                    error={props.errors.length > 0}
                    required={props.required}
                    value={props.value}
                    onBlur={(event) => {
                      props.onValueChanged(event.target.value, true)
                    }}
                    onChange={(event, data) => {
                        props.onValueChanged(data.value, props.validateOnChange)
                    }}/>

        {props.errors.map((error) => (
            <Label key={error.type} basic className="db-error-label">
                <FormattedMessage id={`errors.validation.${error.type}`}/>&nbsp;
                {error.invalidValues ? (
                    <FormattedMessage id='errors.validation.invalid_values' values={{invalidValues: error.invalidValues}}/>
                ) : ""}
            </Label>
        ))}
    </Form.Field>
);

TextInput.propTypes = {
    password: PropTypes.bool, // whether input type is "password"
    label: PropTypes.any,
    value: PropTypes.any.isRequired,
    required: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onValueChanged: PropTypes.func.isRequired,
    validationRules: PropTypes.arrayOf(PropTypes.object),
    errors: PropTypes.arrayOf(PropTypes.object),
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    validateOnChange: PropTypes.bool
};

TextInput.defaultProps = {
    errors: [],
    validateOnChange: false
};

export default TextInput;



// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/TextInput.jsx